import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientComplaintApi } from '../api/patientcomplaint.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientComplaintData, PatientComplaint } from '../../../interfaces/masters/patientcomplaint' ;
@Injectable()
export class PatientComplaintService extends PatientComplaintData {

    constructor(private api: PatientComplaintApi) {
      super();
    }
  
  
    list(url: string): Observable<PatientComplaint[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<PatientComplaint>{
        return this.api.getById(url);
    }

    get(url:string): Observable<any>{
      return this.api.getById(url);
  }
  
    create(url: string, data:PatientComplaint): Observable<PatientComplaint[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:PatientComplaint): Observable<PatientComplaint> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  